export default __webpack_public_path__ + "static/media/ProgressBar4.3497546b.png";